export default "__VITE_ASSET__BN_3ictv__"